export default __webpack_public_path__ + "static/media/Split.60d50cbb.svg";